import { animated, useTransition } from "@react-spring/web";
import { useCallback, useState } from "react";
import Login from "./login";
import Register from "./register";
import { useHttp } from '../../providers/http'
import { useAuth } from "../../providers/auth";
import { Navigate } from 'react-router-dom'

const LoginScreen = () => {
    const http = useHttp();
    const { setToken, state } = useAuth();
    const [error, setError] = useState(null)

    const [type, setType] = useState("login");

    const trans = useTransition(type, {
        from: {
            scale: 0,
            opacity: 0
        },
        enter: {
            opacity: 1,
            scale: 1
        },
        leave: {
            opacity: 0,
            scale: 0.5,
        },
        exitBeforeEnter: true
    })

    const loginFn = useCallback((email, password) => {
        http.post("/user/login", { email, password })
            .then(({ data: { api_token: token } }) => {
                setError(null);
                setToken(token)
            })
            .catch(({ response: { data: { message } } }) => {
                setError(message)
            })
    }, [])

    const registerFn = useCallback((email, password, confirmPassword) => {
        return http.post("/user/register", { email, password, password_confirmation: confirmPassword })
            .then(({ message }) => {
                setError(null);
                return message;
            })
            .catch(({ response: { data: { message } } }) => {
                setError(message)
            })
    }, [])

    if (state.token) {
        return <Navigate to="/mitvaerksted" />
    }

    return (
        <div
            className="bg-repair-pattern-dark bg-skgBlue bg-cover bg-scroll h-screen flex justify-center items-center flex-col space-y-10 text-skgBlue p-10 font-supermolot relative overflow-y-scroll"
        >
            {
                trans((style, item) => (
                    item === "login"
                        ? (
                            <animated.div
                                className="absolute"
                                style={style}
                            >
                                <Login
                                    onSwitch={() => {
                                        setType("registrer")
                                        setError(null);
                                    }}
                                    fn={loginFn}
                                    error={error}
                                />
                            </animated.div>
                        )
                        : (
                            <animated.div
                                className="absolute"
                                style={style}
                            >
                                <Register
                                    onSwitch={() => {
                                        setType("login")
                                        setError(null);
                                    }}
                                    fn={registerFn}
                                    error={error}
                                />
                            </animated.div>
                        )
                ))
            }
        </div>
    )
}

export default LoginScreen;